import React from "react";
import Button from "../../../../components/Button.jsx";
import overlayAnim from "../../../../css/components/overlaymodal-animations.module.css";
import styles from "../css/clinic-services.module.css";

export default function ErrorModal({ open, onClose, message, title = "Error" }) {
  if (!open) return null;

  return (
    <div
      className={`${overlayAnim.modalOverlay} ${open ? overlayAnim.show : overlayAnim.hide}`}
      onClick={onClose}
    >
      <div
        className={`${overlayAnim.modalContent} ${styles.errorModal}`}
        onClick={(e) => e.stopPropagation()}
      >
        <button className={overlayAnim.closeButton} onClick={onClose}>
          ×
        </button>
        <div className={styles.errorHeader}>
          <div className={styles.errorIcon}>⚠️</div>
          <h2>{title}</h2>
          <p className={styles.errorMessage}>{message}</p>
        </div>

        <div className={styles.errorFooter}>
          <Button variant="primary" onClick={onClose}>
            OK
          </Button>
        </div>
      </div>
    </div>
  );
}
